import { render, staticRenderFns } from "./coupon_box.vue?vue&type=template&id=20d7721e"
import script from "./coupon_box.vue?vue&type=script&lang=js"
export * from "./coupon_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coupon_box.vue"
export default component.exports